/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import PriceField, { PriceFieldProps } from './PriceField'

function MinPriceField (props: PriceFieldProps) {
  const { name = 'minPrice', ...others } = props
  const intl = useIntl()
  return (
    <PriceField
      label={intl.formatMessage({
        id: 'min_price',
        defaultMessage: 'Prix minimal'
      })}
      name={name}
      {...others}
    />
  )
}

export default MinPriceField
